import React from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";

const stack = [
  "Python · FastAPI · Django",
  "Node.js · NestJS · Express",
  "React · Next.js · Remix",
  "Flutter · React Native",
  "Postgres · MySQL · Redis",
  "Kafka · RabbitMQ · Celery",
  "AWS · GCP · Azure · Kubernetes",
  "Terraform · GitHub Actions · ArgoCD",
  "LangChain · LlamaIndex · Vector DBs",
  "OpenAI · Vertex AI · Bedrock",
];

export const Stack = () => {
  return (
    <Section
      id="stack"
      eyebrow="Tools we love"
      title="Technology stack"
      subtitle="Battle‑tested choices for speed, safety, and scale."
    >
      <div className="grid md:grid-cols-2 gap-6">
        {stack.map((line) => (
          <Card key={line}>
            <div className="text-gray-800 font-medium">{line}</div>
          </Card>
        ))}
      </div>
    </Section>
  );
};
